<div class="h-full flex flex-col overflow-hidden bg-[var(--main-light)]">
  <ng-container *ngIf="!isLoading">
    <mat-card class="p-4 rounded-2xl bg-[var(--main)] z-10">
      <div class="flex items-center gap-2">
        <h5 class="flex-1 font-semibold">
          {{ actionnaire.actionnaire_ID === 0 ? 'Création d\'un actionnaire' :
          actionnaire.actionnaire_Nom + ' ' + actionnaire.actionnaire_Prenom ||
          'Modification de l\'actionnaire' }}
        </h5>
        <div class="flex items-center gap-2">
          <button
            class="btn-fab txt-primary"
            (click)="postActionnaire()"
            matTooltip="Enregistrer"
          >
            <mat-icon>save</mat-icon>
          </button>
          <button
            *ngIf="actionnaire.actionnaire_ID !== 0"
            class="btn-fab txt-danger"
            (click)="deleteActionnaire()"
            matTooltip="Supprimer"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button class="btn-fab" (click)="close()" matTooltip="Fermer">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>

    <mat-tab-group
      class="action-tabs flex-1 no-margin-field-bottom text-[var(--text)]"
    >
      <mat-tab label="Informations">
        <div class="overflow-auto" style="max-height: calc(100dvh - 200px)">
          <app-informations [actionnaire]="actionnaire"></app-informations>
        </div>
      </mat-tab>
      <mat-tab label="Banque">
        <div class="overflow-auto" style="max-height: calc(100dvh - 200px)">
          <app-banque [actionnaire]="actionnaire"></app-banque>
        </div>
      </mat-tab>
      <mat-tab label="Représentant">
        <div class="overflow-auto" style="max-height: calc(100dvh - 200px)">
          <app-representant [actionnaire]="actionnaire"></app-representant>
        </div>
      </mat-tab>
      <mat-tab label="Actions">
        <div class="overflow-auto" style="max-height: calc(100dvh - 200px)">
          <app-actions [actionnaire]="actionnaire"></app-actions>
        </div>
      </mat-tab>
      <mat-tab label="Dividendes">
        <app-dividendes [actionnaire]="actionnaire"></app-dividendes>
      </mat-tab>
      <mat-tab label="Notes">
        <div class="relative p-4">
          <mat-card class="bg-[var(--main-card)]">
            <quill-editor
              [(ngModel)]="actionnaire.actionnaire_Notes"
              [styles]="{height: '500px'}"
              placeholder="Ecrivez vos notes ici..."
            ></quill-editor>
          </mat-card>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <div class="flex-1 flex items-center justify-center p-4">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </ng-container>
</div>
